import { Injectable, Signal, signal } from '@angular/core';
import { electronBridge, mirrorContextIdFromUrl } from './electron-bridge';
import type { MirrorContext } from '../../../lib/electron-bridge/mirror-context';

@Injectable({ providedIn: 'root' })
export class MirrorContextService {
    isFile = false;
    readonly isMirrorSignal: Signal<boolean> = signal(mirrorContextIdFromUrl !== undefined).asReadonly();
    readonly isFileSignal: Signal<boolean>;
    private readonly _isFileSignal = signal(false);
    private contextPromise: Promise<MirrorContext | null>;

    constructor() {
        this.isFileSignal = this._isFileSignal.asReadonly();
        if (electronBridge && mirrorContextIdFromUrl !== undefined) {
            this.contextPromise = electronBridge.mirrorContext.get(mirrorContextIdFromUrl);
            this.contextPromise.then((ctx) => {
                if (ctx) {
                    this.isFile = ctx.isFile;
                    this._isFileSignal.set(ctx.isFile);
                }
            });
        } else {
            this.contextPromise = Promise.resolve(null);
        }
    }

    getContext(): Promise<MirrorContext | null> {
        return this.contextPromise;
    }
}
